module.exports = __webpack_public_path__ + "static/media/S (16).e283f84a.jpg";